function login(user) {
  return {
    type: 'LOGIN',
    payload: user
  };
}

function logout() {
  return {
    type: 'LOGOUT'
  };
}

function sessionExpired() {
  return { type: 'SESSION_EXPIRED' };
}

function setIsLoading(isLoading) {
  return {
    type: 'LOADING',
    payload: isLoading
  };
}

function setPendingCount(count) {
  return {
    type: 'SET_PENDING_COUNT',
    payload: count
  };
}

export { login, logout, sessionExpired, setIsLoading, setPendingCount };